import { createFileRoute } from '@tanstack/react-router';
import { OrcamentoPage } from '@/components/orcamento';

export const Route = createFileRoute('/_app/vender/orcamentos/novo')({
  component: () => <OrcamentoPage />,
});
